export default __webpack_public_path__ + "assets/images/afde00ab19b32864cdd8fb161f405cbd.svg";